import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, setWorkflowsAction } from '../../reducers/actions';
import { WorkflowService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_WORKFLOWS),
    switchMap(action =>
      WorkflowService.getBySiteId(action.siteId, store).pipe(
        map(data => setWorkflowsAction(data)),
        catchError(retryAuthentication(action$, 'epics/workflows/getWorkflows'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/workflows/getWorkflows.js